export default "__VITE_ASSET__d8c50b75__"